import {inject, Injectable} from '@angular/core';
import {Meta} from '@angular/platform-browser';
import {datadogRum} from '@datadog/browser-rum';
import {ConfigService} from "./core/services/config.service";

@Injectable({
  providedIn: 'root',
})
export class DatadogService {
  private readonly meta = inject(Meta);

  init() {
    const version = this.meta.getTag('name=version')?.content || 'VERSIONPLACEHOLDER';

    // Check if server and datadog-service is set
    version !== 'VERSIONPLACEHOLDER' &&
      ConfigService.getConfig().datadogConfig?.service?.length > 0 &&
      this.startDatadogSession(version);
  }

  // Fetch datadog-config, set version and start datadog-session
  startDatadogSession(version: string): void {
    const datadogConfig: any = ConfigService.getConfig().datadogConfig;
    datadogConfig.version = version;
    datadogRum.init(datadogConfig);
    datadogRum.setGlobalContextProperty('team', ConfigService.getConfig().datadogTeam);
    datadogRum.startSessionReplayRecording();
  }
}
